<template>
    <!-- 二次报价 -->
    <div>
      <!-- 主持人 -->
      <template v-if="role == 'Z'">
        <z ref="roleZ" @nextBtn="nextBtn" @send="send"></z>
      </template>
      <!-- 招标人/招标代理 -->
      <template v-else>
        <t></t>
      </template>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        role: localStorage.getItem("role") ? localStorage.getItem("role") : "T",
      };
    },
    components: {
      z: () => import("./dcbj_role_z.vue"),
      t: () => import("./dcbj_role_t.vue"),
    },
    created() {},
    methods: {
      getData() {
        this.$refs.roleZ.getData();
      },
      nextBtn(para) {
        this.$emit("nextBtn", para);
      },
      send(data) {
        this.$emit("send", data);
      },
    },
  };
  </script>
  
  <style lang='scss' scoped>
  </style>